import { render, staticRenderFns } from "./Generator.vue?vue&type=template&id=487c24d0&scoped=true&"
import script from "./Generator.vue?vue&type=script&lang=js&"
export * from "./Generator.vue?vue&type=script&lang=js&"
import style0 from "./Generator.vue?vue&type=style&index=0&id=487c24d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c24d0",
  null
  
)

export default component.exports